webpackJsonp([256417761794431],{

/***/ 556:
/***/ (function(module, exports) {

	module.exports = {"data":{"articles":{"html":"<p>Ich vermittle Ihnen für Stadtfeste, Festivals oder andere Festivitäten das passende Programm für Groß und/oder Klein: Schwarzlichtspiele und eine Gruselwelt können nicht nur Kinder begeistern. Das Programm ist mobil, hat alle nötigen Materialien dabei und ist flexibel in Größe, Länge und Angebotsspektrum. Für einen reibungslosen Ablauf kann ich vor Ort als Koordinatorin dabei sein.</p>","frontmatter":{"title":"Mobiles (Kinder-) Programm für Veranstaltungen","img":"/static/grafik-22-9ce554827ebe5ab485c118bb59d68ae6.jpg","author":["Hanna"],"id":107}}},"pathContext":{"slug":"/offer/mobiles-programm-fur-veranstaltungen/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---offer-mobiles-programm-fur-veranstaltungen-2c787b156080504bd424.js